export default {
  grievances: "/grievances",
  assignedGrievances: "/grievances/assigned",
  updateGrievance: "/grievances/update",
  deleteGrievance: "/grievances/delete",
};
